export interface ClaimTypeSelected {
  ClaimTypeID: string;
  ClaimTypeCode?: string;
}
